<!--
에러종류 input 컴포넌트
 - 오류내용수정과 검수관련 컴포넌트에서 사용함
-->
<template>
    <div class="container">
        <div class="option-group border border-sky-700">
            <div class="option-row">
                <div class="option-title bg-sky-700 text-white">
                    상품명<br/>
                    색상/사이즈<br/>
                    SKU No.
                </div>
                <div class="option-body">
                    <div class="uk-flex uk-flex-between uk-flex-middle">
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="11"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">다른상품도착</span>
                            <span class="">(상품명/이미지/모델명 다름)</span>
                        </label>

                        <div class="bg-stone-100 p-0d5rem">
                            * 전자제품/부품/악기/장난감(피규어)는 반드시
                            <span class="text-sky-500 text-underline">모델명</span>
                            확인
                        </div>
                    </div>

                    <div class="mt-0d25rem">
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="12"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">색상</span>
                            <span class="">오배송</span>
                        </label>

                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="13"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">사이즈</span>
                            <span class="">오배송</span>
                        </label>

                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="15"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">SKU no. 불일치</span>
                            <span class="">(SKU no. 표시된 경우만 선택)</span>
                        </label>
                    </div>

                    
                </div>
            </div>

        </div>

        <div class="option-group border border-sky-700">
            <div class="option-row">
                <div class="option-title bg-sky-700 text-white">
                    수량
                </div>
                <div class="option-body">
                    <div>
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="21"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">미도착</span>
                            <span class="">(물품이 도착하지 않은 경우) => 오류 이미지 대신</span>
                            <span class="text-red">Invoice 이미지를 등록해 주세요</span>
                        </label>
                    </div>
                    <div class="mt-0d25rem">
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="22"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">수량부족</span>
                            <span class="">(도착한 수량이 적은 경우)</span>
                        </label>
                    </div>
                    <div class="mt-0d25rem pl-2rem">
                        <span class="text-gray-400">* 도착된 수량이 더 많은 경우 => </span>
                        <span class="text-gray-500 font-bold text-underline">도착한 수량은 검수 하시고,</span>
                        <span class="text-red font-bold text-underline">남은 수량은 부분 무자료로 등록</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="option-group border border-sky-700">
            <div class="option-row">
                <div class="option-title bg-green-800 text-white">
                    오염
                </div>
                <div class="option-body">
                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="31"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">변색</span>
                        <span class=""></span>
                    </label>

                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="32"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">얼룩</span>
                        <span class="">(지워지지 않음)</span>
                    </label>

                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="33"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">본드자국</span>
                        <span class="">(지워지지 않음)</span>
                    </label>

                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="34"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">사용흔적</span>
                        <span class="">(지워지지 않음)</span>
                    </label>
                </div>
            </div>
            <div class="option-row">
                <div class="option-title bg-green-800 text-white">
                    파손/스크래치
                </div>
                <div class="option-body">
                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="41"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">파손(전체)</span>
                    </label>
                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="42"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">파손(부분)</span>
                    </label>
                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="43"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">스크래치</span>
                    </label>
                </div>
            </div>

            <div class="option-row">
                <div class="option-title bg-green-800 text-white">
                    포장
                </div>
                <div class="option-body">

                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="2"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">제품박스 파손 (상품은 정상)</span>
                    </label>

                    <label class="uk-margin-right">
                        <input
                            class="uk-radio"
                            type="radio"
                            :value="3"
                            v-model="radioValue"
                            @change="updateValue"
                        />
                        <span class="font-bold">정품박스 아님</span>
                    </label>
                </div>
            </div>
        </div>


        <div class="option-group border border-sky-700">
            <div class="option-row">
                <div class="option-title bg-yellow-400 text-black">
                    유통기한/용량<br />
                    (건강식품만 해당)
                </div>
                <div class="option-body">
                    <div>
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="14"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">유통기한 오류 :</span>
                            <span class="font-bold text-underline text-sky-700">건강식품(비타민 등)</span>
                            <span class="text-underline">=> 1년 미만,</span>
                            <span class="font-bold text-underline text-sky-700">식품/동물영양제</span>
                            <span class="text-underline">=> 6개월 미만</span>
                            <span class="text-underline">=> 이면 오류처리</span>
                        </label>
                    </div>
                    <div class="mt-0d25rem uk-flex uk-flex-between uk-flex-middle">
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="16"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">용량 오류 : </span>
                            <span class="font-bold text-teal-500">캡슐(capsule)</span>
                            <span class=""> 수량, 용량(ml, oz) 다름</span>
                        </label>

                        <div class="bg-stone-100 p-0d5rem">
                            * 건강식품/식품/화장품/향수/샴푸류는 반드시
                            <span class="text-sky-500 text-underline">용량</span>
                            확인
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="option-group border border-sky-700">
            <div class="option-row">
                <div class="option-title bg-cyan-600 text-white">
                    기타 (others)
                </div>
                <div class="option-body">
                    <div>
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="51"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">택(tag) 없음</span>
                            <span class="">(의류는 tag 필수: 상품명/품번/사이즈 표시된 tag)</span>
                        </label>
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="52"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">도난방지택(alarm tag) 있음</span>
                        </label>
                    </div>

                    <div class="mt-0d25rem">
                        <label class="uk-margin-right">
                            <input
                                class="uk-radio"
                                type="radio"
                                :value="99"
                                v-model="radioValue"
                                @change="updateValue"
                            />
                            <span class="font-bold">기타 오류</span>
                            <span class="">(아래 <span class="text-sky-500 text-underline">오류상세</span>에 설명해 주세요)</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        // 라디오 name 속성
        name: String,

        // 초기값
        initValue: Number,
    },
    data: function () {
        return {
            // 선택값
            radioValue: this.initValue,


        };
    },
    watch: {
        // 부모로부터 전달받은 초기값 변경되면 라디오선택값 변경시켜줌
        initValue: function (val) {
            this.radioValue = val;
        }
    },
    methods: {
        updateValue: function (event) {
            // 선택된 라디오버튼에서만 이벤트 발생시킴
            if (event.target.checked) {
                this.$emit('change', this.radioValue);
            }
        }
    },
}
</script>


<style lang="scss" scoped>
.container {
    width: 60rem;
}

// error-type input 사이즈
.option-group {

    //border: 1px solid #cfcfcf;
    padding: 0.25rem;
    margin-top: 0.25rem;

    .option-row {
        display: flex;
        &:not(:first-child) {
            margin-top: 0.125rem;
        }


        .option-title {
            padding: 0.25rem;
            text-align: center;
            width: 8rem;

            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .option-body {
            flex: 1;
            padding: 0.125rem;
            padding-left: 1rem;

            input[type=radio] {
                height: 1.25rem !important;
                width: 1.25rem !important;
            }

            label {
                font-size: 1rem !important;
            }
        }
    }

    .text-underline {
        text-decoration: underline;
    }
}
</style>
